import { render, staticRenderFns } from "./item-node.vue?vue&type=template&id=18ae500c&scoped=true"
import script from "./item-node.vue?vue&type=script&lang=js"
export * from "./item-node.vue?vue&type=script&lang=js"
import style0 from "./item-node.vue?vue&type=style&index=0&id=18ae500c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae500c",
  null
  
)

export default component.exports